import type { SearchResult } from 'conversational-search-client';
import { telemetryGaugeAction } from 'core-events/actions';

export type ResultEvent = 'item.clickthrough' | 'item.download' | 'preview.downloaded';

export function trackResultEvent(event: ResultEvent, contentId: SearchResult['contentId'], isTopResult: boolean): void {
    void telemetryGaugeAction(`conv-search.${event}`, contentId);
    // The tray event fires alongside the surface-agnostic one, which keeps existing
    // totals whole and lets all-results engagement be read as total minus tray.
    if (isTopResult) {
        void telemetryGaugeAction(`conv-search.top-results.${event}`, contentId);
    }
}
